import { AfterViewInit, ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { TimeoutService } from '@df/ng/timeout.service';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import { NewsletterService } from '@df/session/newsletter/newsletter.service';
import { Subscription } from 'rxjs';

@Directive()
export class NewsletterFormComponentDef implements OnInit, AfterViewInit, OnDestroy {
    protected subscriptions = new Subscription();

    /**
     * Newsletter service
     */
    protected newsletter = inject(NewsletterService);

    /**
     * Form
     * important: you need to put #form="ngForm" on form element in template
     */
    @ViewChild('form', { static: false })
    form?: NgForm;

    /**
     * Subscription place, i.e. footer
     */
    @Input()
    source?: string;

    /**
     * Custom success message
     */
    @Input()
    successMessage?: string;

    /**
     * Custom things
     */
    @Input()
    custom?: any;

    /**
     * Access to app
     */
    app = inject(App);

    /**
     * Email to subscribe
     */
    data!: Partial<Newsletter.ISubscriptionFormData>;

    /**
     * Submission status
     */
    readonly status = new Status();

    submit = this.timeoutService.throttle(() => this._submit(), 300);

    constructor(
        protected _ref: ChangeDetectorRef,
        protected timeoutService: TimeoutService
    ) {}

    detectChanges() {
        this._ref.detectChanges();
    }

    /**
     * Sync on init
     */
    ngOnInit() {
        this.reset();
    }

    ngAfterViewInit() {
        if (this.form) {
            this.subscriptions.add(this.form.valueChanges!.subscribe(() => this.detectChanges()));
        }
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Submission
     */
    _submit() {
        const data = <Newsletter.ISubscriptionFormData>{ source: this.source, ...this.data };
        this.newsletter.subscribe(
            this.form,
            this.status,
            data,
            () => this.onSuccess(),
            () => this.onError()
        );
        this.detectChanges();
    }

    protected onSuccess(): void {
        this.reset();
    }

    protected onError(): void {}

    /**
     * Resets form data
     */
    private reset() {
        this.data = {};
    }
}
